import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileWord } from "@fortawesome/free-solid-svg-icons";
import { ASSETS_BASE } from "../../../config/env";

const DocumentHolderSm = ({ title = "", path = "" }) => {
  const ext = title.split(".").pop().toLowerCase();

  const getFileIcon = () => {
    if (ext === "pdf") return faFilePdf;
    if (["doc", "docx"].includes(ext)) return faFileWord;
    return faFileWord;
  };

  const getIconColor = () => {
    if (ext === "pdf") return "#d9534f";
    if (["doc", "docx"].includes(ext)) return "#0275d8";
    return "#6c757d";
  };

  const displayFileName = () => {
    if (title.length > 50) {
      const ext = title.slice(-6);
      return title.slice(0, 25) + "..." + ext;
    }
    return title;
  };

  return (
    <div className="d-flex align-items-center mb-2">
      <div className="d-flex align-items-center me-1">
        <FontAwesomeIcon
          icon={getFileIcon()}
          className="me-2"
          style={{ fontSize: 18, color: getIconColor() }}
        />

        <a
          href={`${ASSETS_BASE}uploads/resume/${path}`}
          download
          className="text-dark text-sm text-decoration-none"
          title={"Download"}
        >
          <span style={{ wordBreak: "break-word" }}>{displayFileName()}</span>
        </a>
      </div>
    </div>
  );
};

export default DocumentHolderSm;
